<template>
  <v-container class="pt-0">
    <div
      class="d-flex justify-end mb-3 modal-processor-test"
      style="height: 90px; align-items: end;"
    >
      <BaseButton
        color="primary"
        @click="executeTestProcessor()"
      >
        Testar processador
      </BaseButton>
    </div>
    <BaseCard
      :has-main-container="true"
      style="border: none;"
    >
      <v-expansion-panels
        v-model="panel"
        :accordion="true"
      >
        <v-expansion-panel class="mb-4 grayf8">
          <v-expansion-panel-header class="font-weight-bold color--text-black-054">
            Configurar - Teste do processador
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <h4 class="color--text-black-054">
              Inputs
            </h4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <BaseButton
                  :has-icon="true"
                  color="primary"
                  class="mx-0 my-3 pa-4"
                  size="small"
                  v-bind="attrs"
                  v-on="on"
                  @click="showProtobufSchema = !showProtobufSchema"
                >
                  <v-icon>{{ showProtobufSchema ? 'mdi-menu-open' : 'mdi-menu-close' }}</v-icon>
                </BaseButton>
              </template>
              <span>{{ showProtobufSchema ? 'Ocultar Schemas de Protobuf' : 'Mostrar schemas de Protobuf' }}</span>
            </v-tooltip>
            <v-row>
              <v-col
                v-if="showProtobufSchema"
                sm="4"
                class="px-0"
              >
                <ProtobofSchema
                  @insert-value="handleValue"
                />
              </v-col>
              <v-col
                :cols="showProtobufSchema ? 8 : 12"
              >
                <BaseInput
                  id="field-text"
                  v-model="testObject.schema"
                  label="Schema"
                  @click="handleClick('field-text')"
                />
                <p class="mb-2 app-font-semibold color--text-black-054">
                  Payload (Deve ser um JSON)
                </p>
                <codemirror
                  ref="field-codemirror"
                  v-model="testObject.payload"
                  class="my-4"
                  :options="{...cmOptions(), mode: 'application/json'}"
                  @focus="handleClick('field-codemirror')"
                />
                <v-select
                  v-model="testObject.options"
                  :items="listSchemas"
                  label="Options"
                  class="my-6"
                  clearable
                  style="max-width: 400px;"
                />
                <v-divider />
                <h4 class="color--text-black-054 py-4">
                  SharedData
                </h4>
                <v-row dense>
                  <v-col sm="4">
                    <BaseInput
                      ref="keySharedData"
                      v-model="sharedDataObject.key"
                      label="Chave"
                    />
                  </v-col>

                  <v-col sm="4">
                    <BaseInput
                      ref="valueSharedData"
                      v-model="sharedDataObject.value"
                      label="Valor"
                    />
                  </v-col>
                  <v-col
                    sm="1"
                    class="text-right app-align-items-center"
                  >
                    <BaseButton
                      type="text"
                      class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                      :is-disabled="!sharedDataObject.key || !sharedDataObject.value"
                      @click="addSharedData(sharedDataObject)"
                    >
                      {{ isEditingSharedData ? 'Atualizar' : 'Adicionar' }}
                    </BaseButton>
                    <BaseButton
                      v-if="isEditingSharedData"
                      type="text"
                      class="app-button__link-text app-button--hide-ripple app-button--no-hover px-2"
                      @click="cancelEditSharedData"
                    >
                      Cancelar
                    </BaseButton>
                  </v-col>
                </v-row>
                <v-row
                  dense
                  class="mb-4"
                >
                  <v-col
                    cols="auto"
                    sm="10"
                    class="pl-0"
                  >
                    <template>
                      <BaseDataTable
                        v-if="visibleSharedData.length"
                        :headers="['', '']"
                        :items="visibleSharedData"
                        :hide-headers="true"
                        :hide-actions="true"
                        background-color="transparent"
                      >
                        <template v-slot:inject-items="{ items }">
                          <tr
                            :key="items.item.key"
                          >
                            <td>
                              {{ items.item.key }}
                            </td>
                            <td>
                              {{ items.item.value }}
                            </td>
                            <td
                              class="text-right app-align-items-center"
                              style="justify-content: flex-end; min-width: 130px;"
                            >
                              <BaseButton
                                type="text"
                                class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                                @click="editSharedData(items.index)"
                              >
                                Editar
                              </BaseButton>
                              <BaseButton
                                type="text"
                                class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                                @click="removeSharedData(items.index)"
                              >
                                Apagar
                              </BaseButton>
                            </td>
                          </tr>
                        </template>
                      </BaseDataTable>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="mb-4 grayf8">
          <v-expansion-panel-header class="font-weight-bold color--text-black-054">
            Resultado - Teste do processador
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="testProcessorSuccess !== null || sharedDataResponse.length">
              <v-alert
                v-if="testProcessorSuccess !== null"
                dense
                text
                :type="testProcessorSuccess ? 'success' : 'error'"
                class="mb-6"
              >
                {{ testProcessorSuccess ? 'Sucesso' : 'Erro' }}
              </v-alert>
              <template v-if="resultTesteLog">
                <div class="app-align-items-center">
                  <p
                    style="cursor: pointer;"
                    @click="expandLog = !expandLog"
                  >
                    <v-icon small>
                      {{ expandLog ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                    {{ expandLog ? 'Reduzir' : 'Expandir' }}
                  </p>
                  <v-spacer />
                  <BaseButton
                    :has-icon="true"
                    class="ma-0 ml-2 pa-4"
                    size="x-small"
                    @click="copyLog(testProcessorLog)"
                  >
                    <v-icon>{{ isLogCopied ? 'mdi-check-all' : 'mdi-content-copy' }}</v-icon>
                  </BaseButton>
                </div>
                <codemirror
                  ref="log-codemirror"
                  v-model="testProcessorLog"
                  class="my-4"
                  :class="{'expand-log-codemirror' : expandLog}"
                  :options="{ ...cmOptions(), readOnly: 'nocursor' }"
                />
                <p
                  v-if="expandLog"
                  style="cursor: pointer;"
                  class="mb-6"
                  @click="expandLog = false"
                >
                  <v-icon small>
                    mdi-chevron-up
                  </v-icon>
                  Reduzir
                </p>
              </template>
              <v-divider v-if="sharedDataResponse.length" />
              <div v-if="sharedDataResponse.length">
                <h4 class="color--text-black-054 pb-2 pt-4">
                  SharedData
                </h4>
                <v-row dense>
                  <template>
                    <BaseDataTable
                      :headers="['', '']"
                      :items="sharedDataResponse"
                      :hide-headers="true"
                      :hide-actions="true"
                      background-color="transparent"
                      :disable-pagination="true"
                      style="width: 100%;"
                    >
                      <template v-slot:inject-items="{ items }">
                        <tr
                          :key="items.item.key"
                        >
                          <td>
                            {{ items.item.key }}
                          </td>
                          <td
                            style="max-width: 450px; padding: 10px 0px!important;"
                          >
                            {{ items.item.value }}
                          </td>
                        </tr>
                      </template>
                    </BaseDataTable>
                  </template>
                </v-row>
              </div>
            </div>
            <div v-else>
              <p class="color--text-black-054 font-weight-bold d-flex justify-center pa-4">
                Sem resultados para serem exibidos
              </p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <BaseSnackbar
        :active-snackbar="feedback"
        :type-snackbar="feedbackColor"
        :text-snackbar="feedbackMessage"
        @closeSnackbar="feedback = !feedback"
      />
    </BaseCard>
  </v-container>
</template>
<script>
import { codemirror } from 'vue-codemirror'
import ProtobofSchema from './ProtobofSchema'
import { mapActions } from 'vuex'
import BaseDataTable from '../../BaseDataTable'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import loader from '../../../global/loader'

export default {
  components: {codemirror, ProtobofSchema, BaseDataTable, BaseSnackbar},
  mixins: [ BaseSnackbarConfiguration ],
  props: {
    openTestProcessor: {
      type: Boolean,
      required: true
    },
    uuidProcessor: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    panel: [0, 1],
    listSchemas: [],
    itemId: '',
    itemFocus: false,
    sharedDataList: [],
    isEditingSharedData: false,
    sharedDataIndex: null,
    testObject: {
      schema: '',
      payload: '',
      options: '',
      shared_data: {}
    },
    sharedDataObject: {
      key: '',
      value: ''
    },
    sharedDataResponse: [],
    showProtobufSchema: false,
    testProcessorSuccess: null,
    testProcessorLog: '',
    resultTesteLog: null,
    testingProcessor: false,
    expandLog: false,
    isLogCopied: false
  }),

  computed: {
    visibleSharedData(){
      return this.sharedDataList.filter((sd, index) => {
        return sd.value !== '' && index !== this.sharedDataIndex
      })
    }
  },

  watch: {
    panel(value) {
      if(value === 0){
        let objectLocalStorage = JSON.parse(localStorage.getItem("inputs-test-processor"))

        this.testObject.payload = ''

        if(objectLocalStorage && objectLocalStorage.payload) {
          setTimeout(() => {
            this.insertValueCodemirror(JSON.stringify(objectLocalStorage.payload), 'field-codemirror')
          }, 200)
        }
      }
    }
  },

  created() {
    this.getSchema()
    this.getAndAddInputsLocalStorage()
  },

  methods: {
    ...mapActions(['apiGetSchemaMessages', 'apiTestProcessor']),

    async getSchema() {
      this.listSchemas = await this.apiGetSchemaMessages()
    },
    cmOptions(){
      return {
        tabSize: 4,
        mode: 'groovy',
        theme: 'base16-dark',
        lineNumbers: true,
        lineWrapping: true,
        line: true,
      }
    },
    handleValue(value) {
      this.insertValueField(value)
    },

    handleClick(value) {
      this.itemId = value
    },

    insertValueCodemirror(value, ref) {
      let editor = this.$refs[ref].codemirror
      let doc = editor.getDoc()
      let cursor = doc.getCursor()
      doc.replaceRange(value, cursor)
    },

    insertValueField(value){
      if(this.itemId === 'field-text') {
        this.testObject.schema = value
      } else {
        this.insertValueCodemirror(value, 'field-codemirror')
      }
    },
    editSharedData(index) {
      const sharedData = this.sharedDataList[index]

      this.sharedDataObject = {
        key: sharedData.key,
        value: sharedData.value
      }

      this.isEditingSharedData = true
      this.sharedDataIndex = index
    },

    cancelEditSharedData() {
      this.sharedDataObject = {
        key: "",
        value: ""
      }
      this.isEditingSharedData = false
      this.sharedDataIndex = null
    },

    addSharedData(sharedData) {
      const newSharedData = {
        key: sharedData.key,
        value: sharedData.value
      }

      if (this.isEditingSharedData) {
        this.sharedDataList.splice(this.sharedDataIndex, 1, newSharedData)
        this.isEditingSharedData = false
        this.sharedDataIndex = null
      } else {
        this.sharedDataList.push(newSharedData)
      }

      this.sharedDataObject = {
        key: "",
        value: ""
      }
    },

    removeSharedData(index) {
      this.sharedDataIndex = index

      this.sharedDataList.splice(this.sharedDataIndex, 1)
      this.sharedDataIndex = null
    },

    async executeTestProcessor(){
      const shared_data = Object.fromEntries(
        this.sharedDataList.map(({ key, value }) => [key, value])
      )

      let payloadObject = this.testObject.payload ? JSON.parse(this.testObject.payload) : ''

      let uuidProcessor = this.uuidProcessor

      const input = {
        schema: this.testObject.schema || '',
        payload: payloadObject || {},
        options: {
          "import_schemas": this.testObject.options || ''
        }
      }

      localStorage.setItem("inputs-test-processor", JSON.stringify({...input, shared_data}))

      this.testObjectAPI = {uuidProcessor, input, shared_data}

      try {
        let result = await this.apiTestProcessor(this.testObjectAPI)
        this.resultTesteLog = result.captured_logs || null

        this.panel = 1
        this.testProcessorSuccess = result.success
        this.sharedDataResponse = Object.entries(result.shared_data).map(([key, value]) => ({ key, value}))

        if(this.resultTesteLog){
          setTimeout(() => {
            this.insertValueCodemirror(this.resultTesteLog, 'log-codemirror')
          }, 200);
        }

        this.showFeedback({
          color: "success",
          message: `Processador testado com sucesso!`,
        })
      } catch (e) {
        loader.stopProgressLoadPage()
        this.showFeedback({
          color: "error",
          message: `Erro ao testar o processador!`,
        })
      }
    },

    getAndAddInputsLocalStorage() {
      if(this.openTestProcessor){
        this.sharedDataList = []
        let objectLocalStorage = JSON.parse(localStorage.getItem("inputs-test-processor")) || null

        if(objectLocalStorage){
          this.testObject = {
            schema: objectLocalStorage.schema,
            payload: JSON.stringify(objectLocalStorage.payload),
            options: objectLocalStorage.options.import_schemas
          }

          Object.keys(objectLocalStorage.shared_data).forEach(key => {
            this.sharedDataList.push({key, value: objectLocalStorage.shared_data[key]})
          })
        }
      }
    },
    async copyLog(log){
      await navigator.clipboard.writeText(log)
      this.isLogCopied = true
      setTimeout(() => {
        this.isLogCopied = false
      }, 900);
    }
  }
}
</script>

<style lang="scss">
.modal-processor-test {
  .CodeMirror.cm-s-base16-dark {
    height: 200px!important;
  }
  .expand-log-codemirror {
    .CodeMirror.cm-s-base16-dark {
      height: auto!important;
    }
  }
}

.CodeMirror,
  .CodeMirror-scroll {
    width: 100% !important;
    min-width: 0 !important;
    overflow-x: auto;
  }
</style>
